export const CONSULTING_SEARCH_CONTEXT = 'consulting';
